var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLogosSreal = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 89.592,
    height: 37.768,
    "data-name": "Gruppe 5833",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Logos_sreal_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h89.592v37.768H0z",
    "data-name": "Rechteck 2328"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#Logos_sreal_svg__a)",
    "data-name": "Gruppe 5330"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.998 8.444c0-.958.428-1.436 1.385-1.436h5.243c3.681 0 5.8 1.689 5.8 4.865a4.225 4.225 0 0 1-2.823 4.411l3.152 6.15a1.8 1.8 0 0 1 .227.706H33.5c-.73 0-1.033 0-1.386-.731l-2.823-5.823H28.03v6.554h-4.032Zm4.032 1.966v2.9h2.294c1.16 0 2.066-.151 2.066-1.436 0-1.261-.907-1.462-2.066-1.462Z",
    "data-name": "Pfad 5907"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.365 8.444c0-.958.428-1.437 1.386-1.437h8.822v1.992a1.252 1.252 0 0 1-1.436 1.411h-4.74v2.9h5.294v3.277h-5.294v3.15h6.3v1.991a1.253 1.253 0 0 1-1.437 1.411h-7.509c-.957 0-1.386-.478-1.386-1.436Z",
    "data-name": "Pfad 5908"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.201 6.957c.68 0 1.008.076 1.159.655l3.756 14.9a3 3 0 0 1 .075.63h-3.3c-.681 0-.883-.05-1.009-.6l-.781-3.226h-3.757l-.731 3.226c-.126.555-.327.6-1.009.6h-3.277a3.3 3.3 0 0 1 .077-.63l3.755-14.9c.151-.579.479-.655 1.16-.655Zm-3.248 9.327h2.5l-1.209-5.168h-.1Z",
    "data-name": "Pfad 5909"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.451 8.444c0-.958.428-1.437 1.386-1.437h2.646v12.73h6.176v1.991a1.252 1.252 0 0 1-1.437 1.411h-7.385c-.958 0-1.386-.478-1.386-1.436Z",
    "data-name": "Pfad 5910"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.857 0a2.83 2.83 0 0 1 2.086.894 2.95 2.95 0 0 1 .881 2.132 2.94 2.94 0 0 1-.874 2.142 2.84 2.84 0 0 1-2.093.893 2.8 2.8 0 0 1-2.094-.893 2.95 2.95 0 0 1-.874-2.142A2.96 2.96 0 0 1 7.754.9a2.83 2.83 0 0 1 2.1-.9m9.856 12v-1.836a3.156 3.156 0 0 0-3.153-3.156H3.153A3.155 3.155 0 0 0 0 10.164V17.1h14.952v1.052H0v1.84a3.15 3.15 0 0 0 3.153 3.152h13.4a3.153 3.153 0 0 0 3.153-3.152v-6.937H4.761V12Z",
    "data-name": "Pfad 5911"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.463 37.69h-1.465v-9.233c0-.483.171-.749.638-.749h.827Z",
    "data-name": "Pfad 5912"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.336 37.69v-7.8h.7c.5 0 .7.266.7.655v.255a2.85 2.85 0 0 1 2.167-.981 2.07 2.07 0 0 1 2.028 1.091 3.6 3.6 0 0 1 2.432-1.091 2.11 2.11 0 0 1 2.276 2.369v5.5h-1.4v-5.424c0-.9-.53-1.31-1.419-1.31a2.64 2.64 0 0 0-1.683.7 2.7 2.7 0 0 1 .046.515v5.521h-1.387v-5.426c0-.9-.547-1.31-1.435-1.31a2.63 2.63 0 0 0-1.622.654v6.082Z",
    "data-name": "Pfad 5913"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.52 37.69v-7.8h.7c.5 0 .7.266.7.655v.255a2.85 2.85 0 0 1 2.167-.981 2.07 2.07 0 0 1 2.027 1.091 3.6 3.6 0 0 1 2.432-1.091 2.11 2.11 0 0 1 2.277 2.369v5.5h-1.4v-5.424c0-.9-.53-1.31-1.42-1.31a2.64 2.64 0 0 0-1.684.7 3 3 0 0 1 .047.515v5.521h-1.387v-5.426c0-.9-.545-1.31-1.435-1.31a2.62 2.62 0 0 0-1.621.654v6.082Z",
    "data-name": "Pfad 5914"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.314 33.791c0-2.182.717-3.975 3.164-3.975 2.463 0 3.165 1.793 3.165 3.975s-.7 3.977-3.165 3.977c-2.447 0-3.164-1.793-3.164-3.977m4.879 0c0-1.916-.374-2.931-1.715-2.931-1.326 0-1.716 1.014-1.716 2.931s.39 2.932 1.716 2.932c1.341 0 1.715-1.013 1.715-2.932",
    "data-name": "Pfad 5915"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.559 37.768a2.68 2.68 0 0 1-2.026-.982v.25c0 .39-.2.654-.717.654h-.688v-9.542c0-.437.141-.748.641-.748h.764v3.4a2.68 2.68 0 0 1 2.026-.981c1.839 0 2.7 1.512 2.7 3.975s-.858 3.976-2.7 3.976m-.468-6.83a2.33 2.33 0 0 0-1.559.656v4.367a2.33 2.33 0 0 0 1.559.654c1.215 0 1.715-1 1.715-2.823s-.5-2.854-1.715-2.854",
    "data-name": "Pfad 5916"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.145 29.022h-1.4v-.889c0-.468.171-.733.639-.733h.764Zm-1.4.872h.748c.483 0 .656.265.656.734v7.063h-1.4Z",
    "data-name": "Pfad 5917"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.421 37.69h-1.4v-9.557c0-.469.172-.733.639-.733h.764Z",
    "data-name": "Pfad 5918"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.696 29.022h-1.4v-.889c0-.468.171-.733.639-.733h.764Zm-1.4.872h.748c.483 0 .654.265.654.734v7.063h-1.4Z",
    "data-name": "Pfad 5919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.903 36.661v.357c0 .609-.827.75-2.542.75-2.433 0-3.181-1.793-3.181-3.977s.795-3.975 3.166-3.975a2.676 2.676 0 0 1 2.916 2.9 12 12 0 0 1-.078 1.434h-4.539c0 1.81.609 2.511 1.872 2.511Zm-1.08-3.477c.017-.14.017-.452.017-.639 0-.749-.3-1.684-1.482-1.684-1.076 0-1.653.686-1.716 2.323Z",
    "data-name": "Pfad 5920"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.745 37.69v-7.8h.7c.5 0 .7.266.7.64v.27a2.88 2.88 0 0 1 2.184-.981 2.11 2.11 0 0 1 2.263 2.381v5.49h-1.386v-5.426c0-.92-.53-1.31-1.42-1.31a2.63 2.63 0 0 0-1.637.654v6.082Z",
    "data-name": "Pfad 5921"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLogosSreal);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Logos_sreal.7f4e6a2312de040623b503dfc213f0cc.svg";